import { Col, Form, FormItemProps, Row, Typography } from 'antd';
import type { ReactNode } from 'react';

export interface FormItemColProps extends FormItemProps {
  label: ReactNode;
  children: ReactNode;
  cols?: number[];
  itemsCenter?: boolean;
  labelClassNames?: string;
  gutter?: [number, number];
}

export const FormItemCol = ({
  children,
  label,
  itemsCenter = true,
  cols,
  labelClassNames,
  help,
  gutter = [16, 16],
  ...props
}: FormItemColProps) => {
  return (
    <Form.Item
      hidden={props.hidden}
      className={props.className}
      style={props.style}
    >
      <Row gutter={gutter} className={itemsCenter ? 'items-center' : ''}>
        <Col xs={24} md={cols?.[0] ?? 4} className=" !text-left">
          <label
            className={`flex items-center gap-1 after:hidden text-w ${labelClassNames}`}
            htmlFor={props.name}
          >
            {label}
          </label>
        </Col>
        <Col xs={24} md={cols?.[1] ?? 20}>
          <Form.Item {...props} noStyle>
            {children}
          </Form.Item>
        </Col>
        {help && (
          <Col xs={24} md={cols?.[2] ?? 8}>
            <Typography.Text type="secondary" style={{ fontSize: 14 }}>
              {help}
            </Typography.Text>
          </Col>
        )}
      </Row>
    </Form.Item>
  );
};
